import styled, { css } from 'styled-components';
import { FaSort } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { inputStyle } from 'lib/styles/index';
import palette from 'lib/styles/palette';
import { useLocation } from 'react-router-dom';
import ErrorDashboardTableItem from 'components/error/ErrorDashboardTableItem';
import useErrorDashboardTable from 'hooks/error/useErrorDashboardTable';
import Pagination from 'components/common/Pagination';
import { DownArrow } from 'lib/styles/icons';
import { useState } from 'react';

const ErrorDashboardTable = ({ done }) => {
  const { pathname } = useLocation();
  const lastPath = pathname.split('/').reverse()[0];

  const [showFilterBox, setShowFilterBox] = useState({
    title: false,
    name: false,
    titleLabel: '종류',
    nameLabel: '세부항목',
  });

  const {
    currentPage,
    searchKeyword,
    errorList,
    count,
    filterTitle,
    filterName,
    setCurrentPage,
    setFilterTitle,
    setFilterName,
    onSortByCreatedAt,
    onSortByUpdatedAt,
    onChangeSearchKeyword,
  } = useErrorDashboardTable(done);

  return (
    <>
      <Header>
        <div className="left">
          <Link to="/admin/error">
            <Tab lastPath={lastPath}>제품 장애 리스트</Tab>
          </Link>
          <Link to="/admin/error/done">
            <Tab lastPath={lastPath}>처리 완료 리스트</Tab>
          </Link>
        </div>
        <Filter>
          <div
            className="filter-item"
            onClick={() => {
              setFilterTitle('');
              setFilterName('');
              setShowFilterBox({
                title: false,
                name: false,
                titleLabel: '종류',
                nameLabel: '세부항목',
              });
              setCurrentPage(1);
            }}
          >
            <div className="filter-selector">필터 초기화</div>
          </div>
          <div className="filter-item">
            <div
              className="filter-selector"
              onClick={() => {
                setShowFilterBox({
                  ...showFilterBox,
                  title: !showFilterBox.title,
                });
              }}
            >
              <div>{showFilterBox.titleLabel}</div>
              <DownArrow />
            </div>
            {showFilterBox.title && (
              <div className="filter-box">
                {['상태', '기기'].map((el, idx) => (
                  <FilterBoxItem
                    filterTitle={filterTitle}
                    key={idx}
                    onClick={e => {
                      setShowFilterBox({
                        ...showFilterBox,
                        title: false,
                        titleLabel: e.target.innerHTML,
                        nameLabel: '세부항목',
                      });
                      setFilterName('');
                      setCurrentPage(1);
                      if (e.target.innerHTML === '상태') {
                        setFilterTitle('notificationType');
                      }
                      if (e.target.innerHTML === '기기') {
                        setFilterTitle('deviceType');
                      }
                    }}
                  >
                    {el}
                  </FilterBoxItem>
                ))}
              </div>
            )}
          </div>
          <div className="filter-item">
            <div
              className="filter-selector"
              onClick={() => {
                setShowFilterBox({
                  ...showFilterBox,
                  name: !showFilterBox.name,
                });
              }}
            >
              <div>{showFilterBox.nameLabel}</div>
              <DownArrow />
            </div>
            {showFilterBox.name && (
              <div className="filter-box">
                {!filterTitle ? (
                  <div style={{ fontSize: 12 }}>종류 미선택</div>
                ) : filterTitle === 'notificationType' ? (
                  ['연결 끊김', '배터리 부족'].map((el, idx) => (
                    <FilterBoxItem
                      filterName={filterName}
                      key={idx}
                      onClick={e => {
                        setShowFilterBox({
                          ...showFilterBox,
                          name: false,
                          nameLabel: e.target.innerHTML,
                        });
                        setCurrentPage(1);
                        if (e.target.innerHTML === '연결 끊김') {
                          setFilterName('연결 끊김');
                        }
                        if (e.target.innerHTML === '배터리 부족') {
                          setFilterName('배터리 부족');
                        }
                      }}
                    >
                      {el}
                    </FilterBoxItem>
                  ))
                ) : (
                  ['컨트롤러', '센서', '허브'].map((el, idx) => (
                    <FilterBoxItem
                      filterName={filterName}
                      key={idx}
                      onClick={e => {
                        setShowFilterBox({
                          ...showFilterBox,
                          name: false,
                          nameLabel: e.target.innerHTML,
                        });
                        setCurrentPage(1);
                        if (e.target.innerHTML === '컨트롤러') {
                          setFilterName('컨트롤러');
                        }
                        if (e.target.innerHTML === '센서') {
                          setFilterName('센서');
                        }
                        if (e.target.innerHTML === '허브') {
                          setFilterName('허브');
                        }
                      }}
                    >
                      {el}
                    </FilterBoxItem>
                  ))
                )}
              </div>
            )}
          </div>
        </Filter>
        <StyledInput
          type="text"
          placeholder="소속, 장소를 입력하세요"
          value={searchKeyword}
          onChange={onChangeSearchKeyword}
        />
      </Header>
      <Body>
        <div className="table-header">
          {done ? (
            <>
              <div className="table-header-cell cell-s">번호</div>
              <div className="table-header-cell">
                <div>장애 발생 일시</div>
                <FaSort className="icon" onClick={onSortByCreatedAt} />
              </div>
              <div className="table-header-cell">
                <div>처리일자</div>
                <FaSort className="icon" onClick={onSortByUpdatedAt} />
              </div>
              <div className="table-header-cell">소속</div>
              <div className="table-header-cell">장소</div>
              <div className="table-header-cell cell-s">장비</div>
              <div className="table-header-cell">Mac 주소</div>
              <div className="table-header-cell">상태</div>
            </>
          ) : (
            <>
              <div className="table-header-cell cell-s">번호</div>
              <div className="table-header-cell">
                <div>장애 발생 일시</div>
                <FaSort className="icon" onClick={onSortByCreatedAt} />
              </div>
              <div className="table-header-cell">소속</div>
              <div className="table-header-cell">장소</div>
              <div className="table-header-cell cell-s">장비</div>
              <div className="table-header-cell">Mac 주소</div>
              <div className="table-header-cell">상태</div>
            </>
          )}
        </div>
        {errorList?.length === 0 ? (
          <div
            style={{
              textAlign: 'center',
              marginTop: 30,
              marginBottom: 30,
              fontWeight: 500,
            }}
          >
            목록이 없습니다
          </div>
        ) : (
          <>
            {errorList?.map((error, idx) => (
              <ErrorDashboardTableItem
                key={error.id}
                error={error}
                idx={idx + 1 + 10 * (currentPage - 1)}
                done={done}
              />
            ))}
            <Pagination
              totalPage={Math.ceil(count / 10)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </>
        )}
      </Body>
    </>
  );
};

export default ErrorDashboardTable;

const Header = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    padding: 10px 20px;
    display: flex;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    background: #fff;

    a + a {
      margin-left: 0.8rem;
    }
  }

  .cell-s {
    width: 350px;
    background: red;
  }
`;

const Tab = styled.div`
  font-size: 11px;
  cursor: pointer;
  &:hover {
    color: ${palette.theme[3]};
  }

  ${props =>
    props.lastPath === 'error' &&
    props.children === '제품 장애 리스트' &&
    css`
      color: ${palette.theme[3]};
    `}

  ${props =>
    props.lastPath === 'done' &&
    props.children === '처리 완료 리스트' &&
    css`
      color: ${palette.theme[3]};
    `}
`;

const StyledInput = styled.input`
  ${inputStyle}
  width: 300px;
  margin-top: 0;
`;

const Body = styled.div`
  margin-top: 1rem;
  margin-bottom: 2rem;
  padding: 0 30px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.1);

  .table-header {
    height: 40px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 12px;
    font-weight: 600;
  }

  .table-header-cell {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon {
    cursor: pointer;
  }

  .cell-s {
    width: 350px;
  }
`;

const Filter = styled.div`
  display: flex;

  .filter-item {
    width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }

  .filter-item + .filter-item {
    margin-left: 15px;
  }

  .filter-selector {
    width: 100%;
    padding: 5px 10px;
    display: flex;
    justify-content: center;
    border-radius: 10px;
    background: #fff;
    color: rgba(0, 0, 0, 0.5);
    font-size: 12px;
    cursor: pointer;
    div + div {
      margin-left: 10px;
    }
  }

  .filter-box {
    width: 100%;
    padding: 0.5rem;
    position: absolute;
    top: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background: #fff;
    font-size: 14px;

    div {
      cursor: pointer;
    }

    div:hover {
      color: blue;
    }

    div + div {
      margin-top: 5px;
    }
  }
`;

const FilterBoxItem = styled.div`
  ${props =>
    props.filterTitle === 'notificationType' &&
    props.children === '상태' &&
    css`
      color: blue;
    `}

  ${props =>
    props.filterTitle === 'deviceType' &&
    props.children === '기기' &&
    css`
      color: blue;
    `}

    ${props =>
    props.filterName === props.children &&
    css`
      color: blue;
    `}
`;
